import { inject, Pipe, PipeTransform } from '@angular/core';
import { AccommodationService } from '@lx/quote-tool/shared/data-access/products';

@Pipe({
  standalone: true,
  name: 'lxAccommodationLabelOptions',
})
export class AccommodationLabelOptionsPipe implements PipeTransform {
  private readonly accommodationService = inject(AccommodationService);

  transform(value: string, labelKey: 'bathRoomTypeLabels' | 'mealOptionLabels'): string {
    if (!value || !labelKey || !this.accommodationService[labelKey]) {
      return '';
    }

    return value
      .split(', ')
      .map((type) => this.accommodationService[labelKey][type] || type)
      .join(', ');
  }
}
